import { useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { invokeAdminPath, getAdminParamsOnPath, RoutingPathsKeyListType, RoutingPathsType } from '../helpers/routing';
import { useSafeNavigate } from '../../../../contexts/routing/useSafeNavigation';

export const useRouting = () => {
    const location = useLocation();

    const navigate = useSafeNavigate();

    const paths = location.pathname.split('/').filter(Boolean);

    //Due to useParams reactivity issues in context we cannot move it into useAdmin
    const getRouteParams = getAdminParamsOnPath(useParams());

    const routeTo = useCallback(async <K extends RoutingPathsKeyListType, InferParams extends boolean = false>(type: K, propParams: InferParams extends true ? Partial<RoutingPathsType[K]> : RoutingPathsType[K], inferParams?: InferParams) => {
        const currentParams = await getRouteParams(type);
        const params = inferParams ? { ...currentParams, ...propParams } : propParams as RoutingPathsType[K];
        invokeAdminPath(pathname => navigate({ pathname }))(type, params);
    }, [getRouteParams, navigate]);

    return {
        routeTo,
        getRouteParams,
        paths,
        pathname: location.pathname
    };
};

